const useOverridesTaskExtraFields = (name, values, params) => {
  const extraParams = { ...params };

  if (name === 'Policy Overrides' || name === 'Offer Overrides') {
    switch (values.overrideAction) {
      case 'Override Branded Title':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        extraParams.allowBrandedTitleCoverage = {
          type: 'boolean',
          name: 'Allow adding coverages (Optional)'
        };
        extraParams.allowBrandedTitleCompColl = {
          type: 'boolean',
          name: 'Allow adding Comp/Coll (Optional)'
        };
        break;
      case 'Override MSRP Too High':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override Excluded VIN':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override Replacement Cost Values':
        extraParams.valuationID = {
          type: 'shorttext',
          name: 'Replacement Cost Valuation ID'
        };
        extraParams.coverageAOrC = {
          type: 'integer',
          name: 'Coverage A or C'
        };
        extraParams.replacementCostTotal = {
          type: 'integer',
          name: 'Replacement Cost Total'
        };
        break;
      case 'Override Application Signing Expiry':
        extraParams.applicationSigningExpiresAt = {
          type: 'date',
          name: 'New Expiry Date',
          disableFuture: false
        };
        break;
    }
  }

  return extraParams;
};
export default useOverridesTaskExtraFields;
